//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head: {},
  data() {
    return {
      title: "باقات أسعار إنشاء  إنشاء تطبيق متجر الكتروني",
      description: "باقات أسعار شهرية وسنوية  لإنشاء تطبيق متجر الكتروني على منصة تجدد",
      services: [
        {
          header: [{ title: "المميزات", }],
          content: [
            {
              title: "تطبيق Native iOS & Android",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "دعم اللغتين (عربي / إنجليزي)",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "المزامنة التلقائية بين المتجر والتطبيقات",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "نظام الإشعارات الفورية",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "لوحة تحكم خاصة بالتطبيق",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "الاختيار بين أكثر من ٢٠ تصميم احترافي",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "طرق عرض مختلفة ومتنوعة للمنتجات",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "بنرات ثابتة/متحركة بطرق عرض غير محدودة",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "شريط الأقسام المتحرك",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "اشعارات بتحديثات حالات التطبيقات",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "إشعارات بتنبيهات السلات المتروكة",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "خاصية البحث بالباركود",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "الدعم الفني المجاني",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "تتبع حالة الطلبات",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "دعم الدفع عن طريق أبل باي",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "خاصية المفضلة",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "تحديد موقع العميل على الخريطة",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: "تخصيص الخط بالتطبيق",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: "تخصيص متقدم لتصميم التطبيق",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: "Deep-Linking - رابط نقل مباشر إلى التطبيق",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: "عداد العروض التنازلي",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: "النوافذ المنبثقة Popups",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: "الاختصارات السريعة على أيقونة التطبيق",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: "شريط التنبيهات والعروض",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: "القصص التفاعلية Stories",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: "الربط مع تطبيقات التحليل والإحصائيات <br> ( Adjust - Firebase - Branch )",
              basic: "",
              grow: "mdi-check",
            },





          ],
        },
      ],
    };
  },

  head() {
    return {
      title: this.title,
      description: this.description,
      keywords: 'انشاء متجر الكتروني, تصميم متجر الكتروني, تجهيز متجر الكتروني',
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:locale", // open graph type
          property: "og:locale",
          content: "ar_AR",
        },
        {
          hid: "og:type", // open graph type
          property: "og:type",
          content: "article",
        },
        {
          hid: "og:title", // open graph title
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description", // open graph description
          property: "og:description",
          content: this.description,
        },
        {
          hid: "og:url", // open graph url
          property: "og:url",
          content: "https://tajadad.app/prices",
        },
        {
          hid: "og:site_name", // open graph site_name
          property: "og:site_name",
          content: "متجرة",
        },
        {
          hid: "og:updated_time", // open graph updated_time
          property: "og:updated_time",
          content: "2022-12-10T00:08:47+03:00",
        },
        {
          hid: "og:image", // open graph image
          property: "og:image",
          content:
            "https://tajadad.app/tajadad.jpg",
        },
        {
          hid: "apple-mobile-web-app-title", // open graph mobile web app title
          name: "apple-mobile-web-app-title",
          content: this.title,
        },

        // open graph twitter
        { name: "twitter:site", content: "@Tajadad" },
        { name: "twitter:card", content: "summary_large_image" },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: "https://tajadad.app/prices",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.description,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content:
            "https://tajadad.app/tajadad.jpg",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://tajadad.app/prices",
        },
      ],
    };
  },
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Article",
          "headline": "تكلفة إنشاء متجر إلكتروني - باقات الأسعار",
          "description": "باقات أسعار مختلفة وتكلفة إنشاء متجرإلكتروني تناسب الجميع مع توفير جميع الخدمات الأساسية اللازمة لإنشاء متجرك والأدوات التي تساعد متجرك في النمو",
          "datePublished": '2022-10-14T10:10:00-07:00',
          "dateModified": '2022-10-14T10:10:00-07:00',
          "publisher": {
            "@type": "Organization",
            "name": "منصة متجرة",
            "logo": {
              "@type": "ImageObject",
              "url": "https://tajadad.app/tajadad.jpg",
            }
          },
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://tajadad.app/prices"
          },
          "author": { "@type": "Person", "name": "matjrah" },
        }]
    }
  }
};
